  <div class="app">
    <div class="from">
      <div class="from__tips">（为规范用户行为，恶意举报用户可能会被管理员禁言或拉黑）</div>
      <div class="from__item">
        <div class="from__item--title" style="margin-top: 0">举报账号：</div>
        <div class="from__item--content">
          {from.account}
        </div>
      </div>
      <div class="from__item">
        <div class="from__item--title">选择举报原因：</div>
        <div class="from__item--content">
          <Checkbox bind:active={from.reason} bind:this={checkbox}></Checkbox>
        </div>
      </div>
      <div class="from__item">
        <div class="from__item--title">举报内容：</div>
        <div class="from__item--content">
          <Textarea bind:value={from.content} placeholder="请详细描述违规的理由，便于平台更准确的判断" counter={100} bind:this={textarea}/>
        </div>
        <div class="from__item--uploder">
          <Upload bind:avatar={from.pic[0]} bind:this={upload}></Upload>
          {#if from.pic[0] || from.pic[1]}
            <Upload bind:avatar={from.pic[1]}></Upload>
          {/if}
        </div>
      </div>
      <div class="from__item">
        <div class="from__item--title" style="color: #1677FF">留下您的手机号，方便我们联系您</div>
        <div class="from__item--content">
          <div class="input">
            <Input name="name" type="number" bind:value={from.phone} placeholder="请输入您的手机号" bind:this={phoneInput}/>
          </div>
        </div>
      </div>
      <div class="sub" on:click={sub}>提交</div> 
    </div> 
  </div>

<script lang="ts">
  import Upload from './Upload/Upload.svelte'
  import Checkbox from './Checkbox/Checkbox.svelte'
  import Textarea from './Textarea/Textarea.svelte'
  import Input from './Input/Input.svelte'
  import { postReport } from '../api/index'
  export let token = ''
  export let subApi = ''
  export let uin = 0
  export let url = ''
  export let company = ''
  export let pageId = 0
  export let pageType = -1
  export let env = ''
  export let closeModal = null
  export let beforeSub = null

  export let afterFailSub = null
  export let afterSuccessSub = null

  // child
  let textarea, checkbox, upload, phoneInput
  
  let from = { 
    account: company,
    reason: 1,
    content: '',
    pic: ['', ''],
    phone: '',
  }

  function subNext() {
    postReport({
      url: subApi,
      data: {
         uin,
         company,
         reportType: from.reason,
         reportContent: from.content,
         imgArr: JSON.stringify(from.pic.filter(item => item !== '')), 
         serverID: '',
         url,
         phone: from.phone,
         pageId,
         pageType 
       },
       env,
       token
    }).then((res) => {
      if (res.data.code === 200 && res.data.errorCode === 0) {
        afterSuccessSub && afterSuccessSub( closeModal ? closeModal : () => {})
      } else { 
        afterFailSub && afterFailSub(
          {status: res.data.errorCode, statusText: res.data.errorMessage}, 
          closeModal ? closeModal : () => {}
        )
       }
    }).catch((err) => {
      afterFailSub && afterFailSub(
          {status: 0, statusText: err},  
          closeModal ? closeModal : () => {}
      )
    })
  }
  function sub() {
    let outRules = 0
    if(!from.reason || from.reason < 1) {
      checkbox.boxWarn()
      outRules++
    }
    if(!from.content) {
      textarea.boxWarn()
      outRules++
    }
    if(from.pic.filter(item => item !== '').length === 0) {
      upload.boxWarn()
      outRules++
    } 
    if(from.phone && !(/^1[3456789]\d{9}$/.test(from.phone))) {
      phoneInput.boxWarn('请输入正确的手机号')
      outRules++
    }
    // /^1[3|4|5|6|7|8|9][0-9]{9}$/
    if(outRules > 0) {
      return
    }
    beforeSub ? beforeSub(from, subNext) : subNext()
  }
</script>

<style lang="less">
  .app {
    line-height: 1.5;
    .from {
      padding: 0 em(22) em(22) em(22);
      width: 100%;
      box-sizing: border-box;
      &__tips {
        font-size: em(10);
        white-space: nowrap;
        transform: scale(0.93);
        color: #1677FF;
        text-align: center;
      }
      &__item {
        color: #333;
        width: 100%;
        &--title {
          font-size: em(12);
          line-height: em(30);
          color: #666;
          margin-top: em(20);
        }
        &--content {
          font-size: em(14);
          width: 100%;
          .input {
            width: 100%;
          }
        }
        &--uploder {
          display: flex;
          margin-top: em(3);
        }
      }
      .sub {
        width: em(168);
        height: em(33);
        background: linear-gradient(180deg, #3388F7 0%, #256BFD 100%);
        border-radius: em(33);
        text-align: center;
        color: #fff;
        line-height: em(33);
        font-size: em(14);
        margin: em(20) auto;
        transition: opacity .3s;
        &:active {
          opacity: 0.5;
        }
      }
    }
  }

  
</style>
